import { makeStyles } from '@material-ui/core/styles';


export default makeStyles((theme) => ({
    root: {
        height: '100%',
        marginBottom: '100px'
    },
    grid: {
        alignItems: 'center',
        justifyContent: 'center'
},
    card: {

    }
}));
